import { makeAutoObservable } from "mobx";

const TYPES = {
  CHILD: "child",
  DAILY_REBBE_VIDEO: "daily-rebbe-video",
  DEFAULT: "default",
  ILLUMINATE: "illuminate",
  MY_MAOR: "my-maor",
  PARTNERS: "partners",
};

class Common {
  constructor() {
    this.project = TYPES.DEFAULT;
    this.selectProjectScreen = true;
    this.options = "default";
    this.characterSubmission = {};
    this.currentCharacterIndex = 0;
    this.writingCompetitionData = null;
    this.currentCharacter = null;
    this.unsubmittedIndexes = null;
    this.isAudioPlayerOpen = false;
    this.selectedPlan = null;
    this.selectedBillingCycle = null;
    // The MyMaor header's "Subscription Packages" modal: whether a header that has it is on
    // the page, and whether it is open (its Subscribe button and "Become a Partner Today!"
    // in the restriction popup open it)
    this.hasSubscriptionModal = false;
    this.isSubscriptionModalOpen = false;

    makeAutoObservable(this);
  }

  get(key) {
    return this[key];
  }

  set(key, value) {
    console.log(key, value);
    this[key] = value;
  }
}

export default Common;
